var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTypehalf = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.448 3.277a.5.5 0 0 0-.896 0L8.888 8.638l-5.96.865a.5.5 0 0 0-.276.854l4.31 4.17-1.017 5.888a.5.5 0 0 0 .724.528L12 18.16l5.33 2.784a.5.5 0 0 0 .725-.528l-1.017-5.889 4.31-4.169a.5.5 0 0 0-.276-.854l-5.96-.865-2.664-5.36ZM12 4.623v12.472a.5.5 0 0 1 .232.057l4.665 2.437-.89-5.153a.5.5 0 0 1 .145-.445l3.768-3.645-5.21-.756a.5.5 0 0 1-.377-.272L12 4.623Z",
  fill: "currentColor"
})));
export { SvgTypehalf as ReactComponent };
export default __webpack_public_path__ + "f287af489b6e62e5c289bf0fafcf1c8b.svg";